import React, { useState, useEffect } from "react";

import Typography from "@mui/material/Typography";
import CircularProgress from "@mui/material/CircularProgress";

import ShowChartIcon from "@mui/icons-material/ShowChart";
import CandlestickChartIcon from "@mui/icons-material/CandlestickChart";

import IconButton from "@mui/material/IconButton";
import ButtonGroup from "@mui/material/ButtonGroup";

import { getIntraDayData } from "../Service/data";
import Chart from "../Charts/Chart";
import ErrorBoundary from "./ErrorBoundry";
import { useSearchParams } from "react-router-dom";

const StockDetailChart = (props) => {
  const [data, setData] = useState();
  const [noData, setNoData] = useState(true);
  const [loading, setLoading] = useState(true);
  let [searchParams, setSearchParams] = useSearchParams();
  const [showRsi, setShowRsi] = useState(false);
  const [showMacd, setShowMacd] = useState(false);
  const [showAdx, setShowAdx] = useState(false);
  const [showRoc, setShowRoc] = useState(false);
  const [showBB, setShowBB] = useState(false);

  const [chartMode, setChartMode] = useState(0);

  useEffect(() => {
    let params = new URLSearchParams(searchParams);

    const rsi = params.get("showRsi");
    setShowRsi(rsi);

    const macd = params.get("showMacd");
    setShowMacd(macd);

    const adx = params.get("showAdx");
    setShowAdx(adx);

    const roc = params.get("showRoc");
    setShowRoc(roc);

    const bb = params.get("showBB");
    setShowBB(bb);
  }, [searchParams]);

  useEffect(() => {
    setLoading(true);
    setNoData(true);
    let time = "1";
    if (props.time !== undefined) {
      time = props.time;
    }
    const fetchData = async () => {
      try {
        getIntraDayData(props.symbol, time).then((data) => {
          setData(data);
          setLoading(false);
        });
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, [props.symbol, props.time]);

  // useEffect(()=>{
  //   console.log("changed");
  //   setLoading(true);
  // }, [props.symbol])

  useEffect(() => {
    if (data !== undefined && data !== null && data.length > 0) {
      // setLoading(false);
      setNoData(false);
    }
  }, [data]);

  return (
    <div>
      {loading && <CircularProgress />}
      {noData ? (
        <div>
          <Typography component="h1" color={"white"}>
            {props.title}
          </Typography>
          <Typography>No data was received</Typography>
        </div>
      ) : (
        <div style={{ display: "flex", flexDirection: "column" }}>
          <ErrorBoundary>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                marginRight: "100px",
              }}
            >
              <Typography component="h1" color={"white"}>
                {props.title}
              </Typography>
              <div>
                <IconButton
                  color={chartMode === 0 ? "success" : "primary"}
                  onClick={() => {
                    setChartMode(0);
                  }}
                >
                  <CandlestickChartIcon />
                </IconButton>
                <IconButton
                  color={chartMode === 1 ? "success" : "primary"}
                  onClick={() => {
                    setChartMode(1);
                  }}
                >
                  <ShowChartIcon />
                </IconButton>
              </div>
            </div>
            <Chart
              title={props.symbol}
              width={props.width}
              height={props.height}
              data={data}
              rsi={showRsi}
              macd={showMacd}
              adx={showAdx}
              roc={showRoc}
              bb={showBB}
              chartMode={chartMode}
            ></Chart>
          </ErrorBoundary>
          <div></div>
        </div>
      )}
    </div>
  );
};

export default StockDetailChart;
